import { useNavigate } from "react-router-dom";
import { Button, Divider } from "@mui/material";
import classes from "./MedicationTemplateControls.module.scss";
import { Add } from "../../../../../assets/icons/Add";
import { IControls } from "../../../../../utils/interfaces";
import { SearchField } from "../../../../common/SearchField/SearchField";

export const MedicationTemplateControls = ({ updateSearchParams }: IControls) => {
  const navigate = useNavigate();
  return (
    <div className={classes.controlsContainer}>
      <h1>Medication templates</h1>
      <div className={classes.controls}>
        <SearchField
          className={classes.searchInput}
          updateSearchParams={updateSearchParams}
          placeholder="Quick search for anything"
        />
        <Divider flexItem orientation="vertical" />
        <Button
          className={classes.createPlan}
          onClick={() => navigate("/medication-templates/create")}
          startIcon={<Add />}
          variant="contained"
        >
          Create
        </Button>
      </div>
    </div>
  );
};
